import { render } from "./PropertyActions.vue?vue&type=template&id=40fe7872"
import script from "./PropertyActions.vue?vue&type=script&lang=js"
export * from "./PropertyActions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/jeronimo/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__